// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#ai-grid-ro-content[data-v-044fc82a] {\r\n    height: 400px;\n}\n[data-v-044fc82a] .dx-clear-button-area {\r\n    margin-left: 8px !important; /* Внешний отступ от поля ввода */\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
